import { configureStore } from '@reduxjs/toolkit';

import uiSlice from './ui-slice';
import dataSlice from './data-slice';
import authSlice from './auth-slice';

export const store = configureStore({
  reducer: { ui: uiSlice.reducer, data: dataSlice.reducer, auth: authSlice.reducer },
});

export default store;
